import { ComponentChildren, createElement } from "preact";
import styles from "./Typography.module.scss";

export type TypographyVariant =
  // Headers
  | "h1" // H1- Header -Black - 20
  | "h2" // H2- Header -Bold - 16
  | "h3" // H3- Header -Regular - 16

  // Buttons
  | "button1" // B1- Button (Select) -Black - 18
  | "button2" // B2- Button -Semibold - 18

  // Tabs
  | "tab-default" // Tab- Default -Semibold - 18
  | "tab-select" // Tab - Select - Heavy - 12
  | "tab-regular" // Tab - Default - Regular - 12

  // Captions
  | "caption1" // Caption 1 - Semibold - 12
  | "caption2" // Caption 2 - Regular - 12
  | "caption3" // Caption 3 - Regular - 10
  | "link"
  | "body1"
  | "body2"
  | "caption";
export type TypographyColor =
  | "primary"
  | "secondary"
  | "white"
  | "black"
  | "grey"
  | "purple"
  | "system-red"
  | "blue"
  | "orange"
  | "green"
  | "header"
  | "header-small"
  | "multiplayer"
  | "light-grey"
  | "purple"
  | "multiplayer-blue"
  | "multiplayer-green"
  | "multiplayer-orange"
  | "grey-black";

interface TypographyProps {
  variant?: TypographyVariant;
  color?: TypographyColor | string;
  children: ComponentChildren;
  className?: string;
  as?: string;
  style?: Record<string, any>;
}

const variantToTag: Record<TypographyVariant, string> = {
  // Headers
  h1: "h1",
  h2: "h2",
  h3: "h3",

  // Buttons
  button1: "span",
  button2: "span",

  // Tabs
  "tab-default": "span",
  "tab-select": "span",
  "tab-regular": "span",

  // Captions
  caption1: "span",
  caption2: "span",
  caption3: "span",

  // Links
  link: "a",

  // Legacy
  body1: "p",
  body2: "p",
  caption: "span",
};

export function Typography({
  variant = "body1",
  color = "primary",
  children,
  className = "",
  as,
  style,
}: TypographyProps) {
  const tag = as || variantToTag[variant];

  const classNames = [
    styles.typography,
    styles[variant],
    styles[color],
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return createElement(tag, { className: classNames, style }, children);
}
